import React, { useEffect, useState } from "react";

import api from "../services/api";
import toast from "react-hot-toast";

export default ({ value, onChange, className = "w-[180px]", filters }) => {
  const [projects, setProjects] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    get();
  }, []);

  async function get() {
    const res = await api.post("/project/search", { per_page: 1000, sort: "-name", ...filters });
    setProjects(res.data.projects);
    setLoading(false);
  }

  async function handleCreateProject() {
    if (!search.trim()) return;
    setCreating(true);
    try {
      const body = { name: search.trim(), status: "active" };
      const res = await api.post("/project", body);
      if (!res?.ok) {
        toast.error("Failed to create project");
        return;
      }
      const created = res.data;
      setProjects([created, ...projects]);
      setSelectedProject(created);
      setSearch("");
      setIsOpen(false);
      if (typeof onChange === "function") onChange(created);
      toast.success("Project created");
    } catch (e) {
      console.log(e);
      toast.error("Failed to create project");
    }
    setCreating(false);
  }

  const filteredProjects = projects.filter((project) => project?.name?.toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    if (value) {
      setSelectedProject(projects.find((p) => p._id === value));
    }
  }, [projects]);

  return (
    <div className="relative">
      <div className="relative">
        <input
          type="text"
          className={`${className} border bg-white text-sm px-3 py-2 rounded-lg ${selectedProject ? "pr-8" : ""}`}
          placeholder="Rechercher un projet..."
          value={selectedProject ? selectedProject.name : search}
          onChange={(e) => {
            setSearch(e.target.value);
            setSelectedProject(null);
            setIsOpen(true);
          }}
          onClick={() => setIsOpen(true)}
        />
        {selectedProject && (
          <div className="absolute right-2 top-0 bottom-0 flex items-center justify-center">
            <button
              className="text-gray-500 hover:text-gray-700 text-sm"
              onClick={() => {
                setSelectedProject(null);
                setSearch("");
                setIsOpen(false);
                onChange(null);
              }}>
              x
            </button>
          </div>
        )}
      </div>

      {isOpen && (
        <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg h-60 overflow-auto">
          {loading ? (
            <div className="flex items-center justify-center h-full">
              <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status"></div>
            </div>
          ) : filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <div
                key={project._id}
                className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setSelectedProject(project);
                  setSearch("");
                  setIsOpen(false);
                  onChange(project);
                }}>
                {project.logo && <img loading="lazy" src={project.logo} alt={project.name} className="w-6 h-6 rounded-full object-cover" />}
                <span>{project.name}</span>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center h-full gap-3 p-3">
              <span className="text-gray-400">Aucun projet trouvé</span>
              {search?.trim() ? (
                <button
                  disabled={creating}
                  onClick={handleCreateProject}
                  className="blue-btn px-3 py-1.5 rounded disabled:opacity-50"
                >
                  {creating ? "Creating…" : `Create "${search.trim()}"`}
                </button>
              ) : null}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
